<template>
  <div class="agency-selector-wrapper">
    <v-select
      id="header-user-agency-select"
      v-model="agencySelected"
      :clearable="false"
      :options="agencyOptions"
      class="mb-0 text-sm agency-selector"
      @option:selected="selectAgency"
    >
      <template v-slot:no-options>
        {{ $t('general.vueSelect.noOptions') }}
      </template>

      <template v-slot:option="option">
        <span>{{ option.name }}</span>
      </template>

      <template v-slot:selected-option="option">
        <span>{{ option?.name || '-' }}</span>
      </template>
    </v-select>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import vSelect from 'vue-select';
import { mapState } from 'pinia';
import { useAuthStore } from '@/stores/auth';

export default defineComponent({
  name: 'TheAgencySelector',
  components: {
    vSelect,
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data() {
    return {
      agencySelected: null as null | any,
      disableButton: false as boolean,
    };
  },
  computed: {
    ...mapState(useAuthStore, ['user', 'agency']),
    agencyOptions(): any[] {
      if (!!this.user && !!this.user.agencies && this.user.agencies.length > 0) {
        return this.user.agencies.map((agency: any) => ({
          ...agency,
          label: agency.name,
          slug: agency.slug,
        }));
      }
      return [];
    },
  },
  watch: {
    agency() {
      this.agencySelected = this.agency;
    },
  },
  mounted() {
    this.agencySelected = this.agency;
  },
  methods: {
    async selectAgency() {
      this.disableButton = true;
      if (this.agencySelected.slug !== localStorage.getItem('agency')) {
        localStorage.setItem('agency', this.agencySelected.slug);
        this.authStore.setAgency(this.agencySelected);
        
        if (this.agencySelected.isCollaborator) {
          localStorage.setItem('isCollaborator', this.agencySelected.isCollaborator);
          this.$router.push({ name: "collaboratorDashboard" });
          return;
        }
      }
      window.location.replace(import.meta.env.VITE_APP_URL);
      this.disableButton = false;
    },
  },
});
</script>

<style lang="scss">
.agency-selector {
  width: 100%;
  min-width: 12rem;
  --vs-dropdown-option--highlight-bg: #000000;
  --vs-dropdown-option--highlight-color: #ffffff;
  --vs-selected-color: #000000;

  .vs__selected {
    font-size: 12px;
    color: #000000;
    font-weight: 600;
    margin: 0;
    padding: 0 0 0 4px;
    display: flex;
    align-items: center;
    height: 100%;
    
    span {
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 1;
    }
  }

  .vs__dropdown-toggle {
    height: 28px;
    border-radius: 0;
    border-color: #dee2e6;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .vs__search {
    margin: 0;
    padding: 0 4px;
    height: 100%;
  }

  .vs__actions {
    padding: 0 4px 0 0;
  }
}
</style>
